<template>
  <div class="h-full group" @click="expandCard" @mouseover="onMouseOver" @mouseout="onMouseOut">
    <div ref="expandablePanelElement" class="absolute left-0 scroll-anchor" />
    <div
      class="flex flex-col justify-between w-full border p-4 transition-colors duration-1000 ease-in-out rounded-lg"
      :class="{
        'bg-neutral-background-secondary border-primary-border-default': isHoveredOver,
        'min-h-[90px] border-neutral-border-default': !expansionPanel.isShown.value,
        'h-fit border-primary-border-default': expansionPanel.isShown.value,
      }"
    >
      <ExpansionPanel
        :model-value="expansionPanel.isShown.value"
        disable-close-animation
        disable-open-animation
        :class="{
          'space-y-2.5': expansionPanel.isShown.value,
        }"
      >
        <template #activator>
          <div class="flex space-x-2.5">
            <FullViewButton
              :review-item="reviewItem"
              :pdf-price="pdfPrice"
              :is-pdf-price-loading="isPdfPriceLoading"
              :is-mira-integration-enabled="isMiraIntegrationEnabled"
              @fetch-pdf-price="getArticlePdfPrice"
            />

            <div
              class="text-sm text-neutral-text-body"
              :class="{
                'line-clamp-3': !expansionPanel.isShown.value,
              }"
            >
              {{ extractedText }}
            </div>
          </div>
        </template>

        <template #default>
          <div class="w-full">
            <div class="flex items-center justify-between w-full gap-4">
              <slot name="expanded-header">
                <a class="underline flex items-center" :href="itemUrl" target="_blank" @click.stop>
                  <SourceIcon :review-item="reviewItem" />
                </a>
              </slot>

              <div class="text-primary-text-default flex items-center ml-auto">
                id:
                <p v-html="formattedId" />
              </div>
            </div>
          </div>
        </template>
      </ExpansionPanel>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, toRef } from "vue";
import ExpansionPanel from "@app/components/Global/ExpansionPanel.vue";
import FullViewButton from "../ReviewItemDetails/components/FullViewButton.vue";
import SourceIcon from "../ReviewItemDetails/components/SourceIcon.vue";
import { ReviewItem } from "@core/domain/models/reviewItem.model";
import { useReviewItemDetails } from "../ReviewItemDetails/use-review-item-details";
import useExpansionPanel from "@app/composables/use-expansion-panel";

const expansionPanel = useExpansionPanel();

const props = withDefaults(
  defineProps<{
    reviewItem: ReviewItem;
    extractedText: string;
    itemUrl?: string;
  }>(),
  {
    itemUrl: "",
    extractedText: "",
  },
);

const expandablePanelElement = ref<HTMLElement>();

const {
  isHoveredOver,
  formattedId,
  pdfPrice,
  isPdfPriceLoading,
  isMiraIntegrationEnabled,
  getArticlePdfPrice,
  expandCard,
  onMouseOver,
  onMouseOut,
} = useReviewItemDetails(toRef(props, "reviewItem"), expansionPanel, expandablePanelElement);
</script>
